<div class="wrapper">


  <h2>Academate: Your LLM-powered systematic literature review mate</h2>

  <video class="intro-clip"
         controls
         preload="metadata"
         src="assets/clips/intro-clip.mp4">
  </video>
  <div class="start-wrapper">
    <a
      mat-fab extended
      routerLink="/project"
      class="start-btn">
      <mat-icon>backup_table</mat-icon>
      <div>Start with your own Project</div>
    </a>
  </div>
  <h3>Welcome to Academate</h3>

  <img src="assets/fig_1.png" alt="graphical abstract" height="auto" width="100%"/>


  <p>
    Meet your academic mate, designed to support and streamline your systematic review process. By leveraging
    cutting-edge Natural Language Processing (NLP) and Large Language Model (LLM) technology, Academate saves you
    valuable time, allowing you to focus on what truly matters in your research.
  </p>
  <h3>What Academate Can Do for You:</h3>
  <ul>
    <li>
      <strong>Smart Search Query Creation:</strong><br/>
      After you provide your research topic and initial key terms, Academate transforms them into a precise search
      query. For greater transparency, as alternative or addition Academate helps identify relevant synonyms, which you
      can adopt to create a more structured and comprehensive search strategy.
    </li>
    <li>
      <strong>Database Selection:</strong><br/>
      You can choose the relevant databases where Academate should search for publications related to your topic and
      define a time restriction.
    </li>
    <li>
      <strong>Screening and Inclusion Process:</strong><br/>
      Once you provide inclusion and exclusion criteria, Academate screens the titles and abstracts, and later the full
      texts, of the identified publications to determine their relevance. At any stage, you have the option to override
      Academate's decision for in-/ exclusion of a publication.
    </li>
    <li>
      <strong>Interactive Data Extraction:</strong><br/>
      You can chat with all or individual included publications, enabling faster data extraction and efficient quality
      evaluation of the studies.
    </li>
    <li>
      <strong>Flow Chart Generation:</strong><br/>
      Academate provides you with a detailed flow chart summarizing the inclusion and exclusion process for the
      identified publications, ensuring a clear and organized overview of your systematic review.
    </li>
  </ul>
  <p>
    Academate is here to help you overcome infollution and reduce the
    burden of manual literature screening, leaving you more time to
    advance your field. Embrace a simpler, faster, and more reliable
    approach to managing and synthesizing the ever-growing body of
    scientific knowledge.
  </p>
  <br/>
  <app-introduction-studies></app-introduction-studies>



  <app-faq></app-faq>
</div>
<app-footer></app-footer>
